import React from "react";
import PageWithConfigurator from "../../global/pageWithConfigurator/pageWithConfigurator";
import ChallengerConversionModule from "./challengerConversion/index";
import PackageSalesModule from "./packagesSales/index";

const pageConfig = {
  pageName: "Packages",
  configuratorWidth: 410,
  moduleList: [PackageSalesModule, ChallengerConversionModule]
};

const PackagesPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default PackagesPage;
